// extracted by css-extract-rspack-plugin
export default {"progressBarLine":"KrTWzHWZ","animateLimits":"u6fWyC6X"};